import * as Actions from '../../../redux/actions'

import React, { Component } from 'react'
import { member_area_router, validate, validate_fields } from "../Common/RegExValidate"

import Banner from '../Common/Banner.jsx'
import EstablishmentContainer from './EstablishmentContainer'
import Header from '../Header/Header'
import ItineraryMap from "../Common/Trip/ItineraryMap"
import Loader from 'react-loader-spinner'
import MemberActionsInitial from "../Common/MemberActions/MemberActionsInitial"
import MemberAreaContainer from "../SocialPage/MemberAreaContainer"
import PageNotFound from '../ErrorPage/PageNotFound'
import PrivateTripEstablishment from "../Common/Trip/PrivateTripEstablishment"
import Profile from '../Common/Profile/ProfileBar.jsx'
import { Redirect } from "react-router-dom"
import TimelineWizardContainer from "../Common/TimelineWizardContainer"
import TripComtainer from "../Common/Trip/TripContainer"
import { connect } from 'react-redux'
import { list_container_mode } from '../Common/RegExValidate'
import "./EstablishmentPage.css"

class EstablishmentPage_ extends Component {
    /* update screen size */
    updateDimensions = () => {
        this.props.setScreenSize(window.screen.width, window.screen.height)
        this.props.setBodyClientSize(document.body.clientWidth, document.documentElement.scrollHeight)
        this.props.setAppMenu(document.body.clientWidth)
    }
    /* initial component */
    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
        this.props.setSwitchContainer(member_area_router.establishment)

        this.props.setAppMenuBookingButtonStatus(true)

    }
    /* destory component */
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions)
    }
    render() {
        const lang = this.props.lang
        const { preload, switch_container, tripMode } = this.props
        return (
            validate(lang, validate_fields.languages) ?
                <div style={{
                    height: "auto",
                }}>
                    {preload ? <Loader
                        type="Rings"
                        color="#19BC9B"
                        className="se-pre-con"
                        height={150}
                        width={150}
                        style={{
                            backgroundColor: "#FFFFFF"
                        }} /> : ""}

                    {switch_container === member_area_router.establishment &&
                        <React.Fragment>
                            <Header bg_color={"#FFFFFF"} text_color={"var(--frameBlack)"} />
                            <EstablishmentContainer props={this.props} />
                        </React.Fragment>
                    }

                    {switch_container === member_area_router.memberAreaTrip &&
                        <React.Fragment>
                            {tripMode === list_container_mode.map ?
                                <React.Fragment>
                                    <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} header_height={"half"} />
                                    <TimelineWizardContainer listDisplayFormat={list_container_mode.map} />
                                    <ItineraryMap />
                                </React.Fragment> :
                                (tripMode === list_container_mode.timeline ?
                                    <React.Fragment>
                                        <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} />
                                        <TimelineWizardContainer listDisplayFormat={list_container_mode.timeline} />
                                        <PrivateTripEstablishment />
                                    </React.Fragment> :
                                    <TripComtainer />)}
                        </React.Fragment>}
                    {(switch_container === member_area_router.trips
                        || switch_container === member_area_router.bucketList
                        || switch_container === member_area_router.favorites
                        || switch_container === member_area_router.personalInfo
                        || switch_container === member_area_router.muvTribe)
                        &&
                        <React.Fragment>
                            <Header bg_color={"rgba(25,25,25, 1)"} text_color={"var(--mainWhite)"} />
                            <Banner />
                            <Profile />
                            <MemberAreaContainer />
                        </React.Fragment>}

                    <MemberActionsInitial />
                </div>
                :
                <Redirect to={"error"} component={PageNotFound} />
        )
    }
}


const mapStateToProps = state => {
    return {
        preload: state.Setting.preload,
        switch_container: state.Member.switch_container,
        lang: state.Setting.lang,
        tripMode: state.Member.tripMode,
    }
}

const mapDispatchToProps = {
    setBodyClientSize: Actions.setBodyClientSize,

    setScreenSize: Actions.setScreenSize,
    setAppMenu: Actions.setAppMenu,
    setScreenVerticalIsTop: Actions.setScreenVerticalIsTop,
    setAppMenuBookingButtonStatus: Actions.setAppMenuBookingButtonStatus,

    setSwitchContainer: Actions.setSwitchContainer,
}

const EstablishmentPage = connect(mapStateToProps, mapDispatchToProps)(EstablishmentPage_)
export default EstablishmentPage
